export default __webpack_public_path__ + "static/media/tree4.1d5b243f.png";